import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    ContactDetailsEnumerationsDocument,
    ContactDetailsEnumerationResponse,
    CustomerEnumerationResponse,
    CustomerEnumerationsDocument,
    OrderEnumerationResponse,
    OrderEnumerationsDocument,
    DeliverableEnumerationResponse,
    DeliverableEnumerationsDocument
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Enumeration extends Client {
    constructor() {
        super()
    }

    public async readContactDetailsEnumerations(): Promise<ContactDetailsEnumerationResponse> {
        try {
            const response =  await this.client.request(ContactDetailsEnumerationsDocument)
            return response.contactDetailsEnumerations
        } catch (error) {
            this.handleError(error)
        }
    }

    public async readCustomerEnumerations(): Promise<CustomerEnumerationResponse> {
        try {
            const response =  await this.client.request(CustomerEnumerationsDocument, null)
            return response.customerEnumerations
        } catch (error) {
            this.handleError(error)
        }
    }

    public async readDeliverableEnumerations(): Promise<DeliverableEnumerationResponse> {
        try {
            const response =  await this.client.request(DeliverableEnumerationsDocument, null)
            return response.deliverableEnumerations
        } catch (error) {
            this.handleError(error)
        }
    }

    public async readOrderEnumerations(): Promise<OrderEnumerationResponse> {
        try {
            const response =  await this.client.request(OrderEnumerationsDocument)
            return response.orderEnumerations
        } catch (error) {
            this.handleError(error)
        }
    }
}
